import { RendererRuntime } from '../runtime';
import { LayoutBase } from './LayoutBase';
import Layout from './index';

export default class extends LayoutBase {
  getSize(): { width: number; height: number } {
    return { width: 0, height: 0 };
  }
  getConditionWidget(widgets: ILayout[]) {
    // 查找第一个condition生效的元素
    const widget = widgets.find((widget) => {
      const { condition } = widget;
      if (!condition) {
        // 没有condition时，代表默认显示
        return true;
      } else {
        const conditionNode = this.runtime.getDataItem<ICondition>(condition);
        return conditionNode ? this.condition(conditionNode) : false;
      }
    });
    return widget;
  }
  draw(): void {
    const { posi, renderer, dataItem } = this;
    const { children = [], movable = false } = dataItem as ISlot;

    // 如果是空children，则不绘制；当是复杂功能时可能会是空
    if (!children?.length) return;

    // 查询要渲染的slot的组件
    const { slotDisplayAll = false } = renderer.options.renderTheme ?? {};

    const slotPosi = { ...posi };

    // 当可移动时，选择位置
    const movablePositions = children.filter(
      (item) => item.tagType == 'Position'
    );
    if (movable && movablePositions.length) {
      const movablePosition = movablePositions?.find(
        (item) => !!item._curSlotPosition
      );
      if (movablePosition) {
        slotPosi.x = movablePosition.x ?? 0;
        slotPosi.y = movablePosition.y ?? 0;
      }
    }

    // 过滤非元素类的widget
    const widgets = children.filter((item) => item.tagType == 'Item');
    // 如果是显示全部
    if (slotDisplayAll) {
      new Layout(renderer).draw(widgets, slotPosi);
    } else {
      // 获取需要渲染的widget
      let widget;
      if ((this.dataItem as ISlot).type == 'condition') {
        widget = this.getConditionWidget(widgets);
      } else if (this._parameter) {
        // 通过parameter(默认展示项ref)选取，找不到时回退到第一个
        widget =
          widgets.find((item) => item.ref == this._parameter) ?? widgets?.[0];
      } else {
        widget = widgets?.[0];
      }

      if (widget) {
        new Layout(renderer).draw([widget], slotPosi);

        // 绘制之后，将容器的高度和宽度设置为widget的高度和宽度
        const { ref, _id } = widget;
        if (_id) {
          const stateKey = RendererRuntime.generateStateKey(
            ref.replace('@', ''),
            _id
          );
          const { width, height } = this.runtime.state[stateKey] ?? {};
          this.setRuntimeData({ width, height });
        }
      }
    }
  }
}
